import { SVGProps } from 'react';

const CursorHoverIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width || '18'}
      height={props?.height || '18'}
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clipPath="url(#clip0_7313_12546)">
        <path
          d="M13.2539 0.703125H15.8906C16.6673 0.703125 17.2969 1.33274 17.2969 2.10938V4.74609M17.2969 7.55859V10.1779C17.2969 10.9545 16.6673 11.5842 15.8906 11.5842H13.4057M10.4414 0.703125H7.78071C7.00407 0.703125 6.37446 1.33274 6.37446 2.10938V4.74609M3.81712 12.1942L2.10937 13.9019C1.5602 14.451 1.5602 15.3415 2.10937 15.8906C2.65855 16.4398 3.54895 16.4398 4.09813 15.8906L5.80588 14.1829L6.78442 16.4487C6.85484 16.6116 6.95557 16.7597 7.08124 16.885C7.63042 17.4342 8.52082 17.4342 9.07 16.885C9.25023 16.7053 9.37807 16.4799 9.43977 16.233L11.4285 8.27807C11.5444 7.8146 11.4211 7.30368 11.0588 6.94129C10.6964 6.57889 10.1854 6.45564 9.72197 6.57151L1.76695 8.56027C1.52006 8.62198 1.29466 8.74982 1.11498 8.93004C0.565804 9.47922 0.565804 10.3696 1.11498 10.9188C1.24033 11.0444 1.38838 11.1452 1.55127 11.2156L3.81712 12.1942Z"
          stroke={props?.fill || '#616161'}
          strokeWidth="1.29"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7313_12546">
          <rect width={props?.width || '18'} height={props?.height || '18'} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CursorHoverIcon;
